(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["d2c-icon-drawers"] && !Shopify.designMode) return;
  try {
    const root = document.querySelector('.header-wrapper.overrides .header__icons')
  if (root && !root.dataset.d2cIconBound) {
    root.dataset.d2cIconBound = 'true'
    const drawers = root.querySelectorAll('.d2c-icon-drawer')

    const closeAll = () => {
      for (const drawer of drawers) {
        drawer.classList.remove('is-open')
        drawer.querySelector('.d2c-icon-drawer__toggle')?.setAttribute('aria-expanded', 'false')
      }
    }

    const openDrawer = (drawer) => {
      closeAll()
      drawer.classList.add('is-open')
      drawer.querySelector('.d2c-icon-drawer__toggle')?.setAttribute('aria-expanded', 'true')
    }

    let openTimer
    let closeTimer

    for (const drawer of drawers) {
      const toggle = drawer.querySelector('.d2c-icon-drawer__toggle')
      drawer.addEventListener('mouseenter', () => {
        clearTimeout(openTimer)
        clearTimeout(closeTimer)
        const delay = root.querySelector('.d2c-icon-drawer.is-open') ? 0 : 200
        openTimer = setTimeout(() => openDrawer(drawer), delay)
      })
      drawer.addEventListener('mouseleave', () => {
        clearTimeout(openTimer)
        closeTimer = setTimeout(closeAll, 200)
      })
      toggle?.addEventListener('click', (event) => {
        event.preventDefault()
        event.stopImmediatePropagation()
        if (!window.matchMedia('(hover: hover)').matches) {
          if (drawer.classList.contains('is-open')) closeAll()
          else openDrawer(drawer)
        }
      }, true)
    }
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') closeAll()
    })
    document.addEventListener('click', (event) => {
      if (!root.querySelector('.d2c-icon-drawer.is-open')) return
      if (event.target.closest('.d2c-icon-drawer')) return
      closeAll()
    })

    const localeForm = root.querySelector('#D2cLocaleForm')
    const countryInput = localeForm?.querySelector('input[name="country_code"]')
    localeForm?.querySelectorAll('button[data-country]').forEach((button) => {
      button.addEventListener('click', (event) => {
        event.preventDefault()
        event.stopPropagation()
        if (!countryInput || button.disabled) return
        countryInput.value = button.getAttribute('data-country')
        localeForm.submit()
      })
    })

    const dawn = document.querySelector('cart-drawer')
    const cartDrawer = root.querySelector('.d2c-icon-drawer--cart')
    const bubble = document.getElementById('cart-icon-bubble')
    const miniCart = document.getElementById('D2cMiniCart')

    const parseSection = (html) => {
      const doc = new DOMParser().parseFromString(html, 'text/html')
      return doc.querySelector('.shopify-section') || doc.body
    }

    const syncMiniCart = () => {
      const source = bubble?.querySelector('#D2cMiniCartSource')
      if (!source || !miniCart) return
      miniCart.innerHTML = source.innerHTML
      source.remove()
    }

    const changeQty = (line, quantity) => {
      if (!window.routes?.cart_change_url || !line) return
      miniCart?.setAttribute('aria-busy', 'true')
      fetch(window.routes.cart_change_url, {
        ...fetchConfig(),
        body: JSON.stringify({
          line,
          quantity,
          sections: ['cart-icon-bubble']
        })
      })
        .then((response) => response.json())
        .then((state) => {
          if (state.errors || !state.sections?.['cart-icon-bubble'] || !bubble) return
          bubble.innerHTML = parseSection(state.sections['cart-icon-bubble']).innerHTML
          syncMiniCart()
          if (typeof publish === 'function' && window.PUB_SUB_EVENTS?.cartUpdate) {
            publish(PUB_SUB_EVENTS.cartUpdate, { source: 'd2c-mini-cart' })
          }
        })
        .catch((error) => {
          console.error('Bag cart quantity update failed', error)
        })
        .finally(() => {
          miniCart?.removeAttribute('aria-busy')
        })
    }

    if (bubble) {
      new MutationObserver(syncMiniCart).observe(bubble, { childList: true })
    }

    document.getElementById('D2cIconCart')?.addEventListener('click', (event) => {
      const button = event.target.closest('[data-d2c-qty]')
      if (!button) return
      event.preventDefault()
      event.stopPropagation()
      changeQty(Number(button.dataset.line), Number(button.dataset.quantity))
    })

    if (dawn && cartDrawer) {
      const syncFromDawn = () => {
        if (dawn.classList.contains('active')) {
          dawn.classList.remove('active')
          document.body.classList.remove('overflow-hidden')
          openDrawer(cartDrawer)
        }
      }
      new MutationObserver(syncFromDawn).observe(dawn, { attributes: true, attributeFilter: ['class'] })
    }
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["d2c-nav"] && !Shopify.designMode) return;
  try {
    const drawer = document.querySelector('#menu-drawer')
  if (drawer && !drawer.dataset.d2cDrawerBound) {
    drawer.dataset.d2cDrawerBound = 'true'

    // Capture phase: Dawn's MenuDrawer binds a close-submenu handler to every
    // button in the drawer, and it registered first, so bubbling is too late.
    drawer.addEventListener(
      'click',
      (event) => {
        const toggle = event.target.closest('.d2c-drawer__toggle')
        if (!toggle) return
        event.preventDefault()
        event.stopPropagation()

        const controls = toggle.getAttribute('aria-controls')
        const opening = toggle.getAttribute('aria-expanded') !== 'true'
        for (const other of drawer.querySelectorAll('.d2c-drawer__toggle')) {
          const isOpen = other.getAttribute('aria-controls') === controls && opening
          other.setAttribute('aria-expanded', isOpen ? 'true' : 'false')
          const panel = document.getElementById(other.getAttribute('aria-controls'))
          if (panel) panel.hidden = !isOpen
        }
      },
      true
    )
  }

  const nav = document.querySelector('.header__d2c-nav')
  if (nav && !nav.dataset.d2cBound) {
    nav.dataset.d2cBound = 'true'
    const header = nav.closest('.header-wrapper')
    const items = nav.querySelectorAll('.d2c-mega')
    let openTimer
    let closeTimer

    const syncHeader = () => {
      header?.classList.toggle('is-mega-open', Boolean(nav.querySelector('.d2c-mega.is-open')))
    }

    const closeAll = () => {
      for (const item of items) {
        item.classList.remove('is-open')
        const toggle = item.querySelector('.d2c-mega__toggle')
        if (toggle) toggle.setAttribute('aria-expanded', 'false')
      }
      syncHeader()
    }

    const openItem = (item) => {
      for (const other of items) {
        const isCurrent = other === item
        other.classList.toggle('is-open', isCurrent)
        other.querySelector('.d2c-mega__toggle')?.setAttribute('aria-expanded', isCurrent ? 'true' : 'false')
      }
      syncHeader()
    }

    for (const item of items) {
      const toggle = item.querySelector('.d2c-mega__toggle')
      item.addEventListener('mouseenter', () => {
        clearTimeout(openTimer)
        clearTimeout(closeTimer)
        const delay = nav.querySelector('.d2c-mega.is-open') ? 0 : 200
        openTimer = setTimeout(() => openItem(item), delay)
      })
      item.addEventListener('mouseleave', () => {
        clearTimeout(openTimer)
        closeTimer = setTimeout(closeAll, 200)
      })
      toggle?.addEventListener('click', (event) => {
        event.preventDefault()
        clearTimeout(openTimer)
        clearTimeout(closeTimer)
        if (item.classList.contains('is-open')) closeAll()
        else openItem(item)
      })
    }

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') closeAll()
    })
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["d2c-shop-nav"] && !Shopify.designMode) return;
  try {
    const shop = document.querySelector('.header-wrapper.overrides .d2c-shop:not(.d2c-shop--mobile)')
  if (shop && !shop.dataset.d2cShopBound) {
    shop.dataset.d2cShopBound = 'true'
    const toggle = shop.querySelector('.d2c-shop__toggle')
    let openTimer
    let closeTimer

    const closeShop = () => {
      shop.classList.remove('is-open')
      toggle?.setAttribute('aria-expanded', 'false')
    }

    const openShop = () => {
      shop.classList.add('is-open')
      toggle?.setAttribute('aria-expanded', 'true')
    }

    shop.addEventListener('mouseenter', () => {
      clearTimeout(openTimer)
      clearTimeout(closeTimer)
      openTimer = setTimeout(openShop, shop.classList.contains('is-open') ? 0 : 200)
    })
    shop.addEventListener('mouseleave', () => {
      clearTimeout(openTimer)
      closeTimer = setTimeout(closeShop, 200)
    })
    shop.addEventListener('focusout', (event) => {
      if (!shop.contains(event.relatedTarget)) closeShop()
    })
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') closeShop()
    })
  }
  } catch(e) { console.error(e); }
})();

})();
